import React, { useEffect, useRef } from 'react'
import { getUrlParams, removeUrlParam } from '../utils/helpers/common'
import { useSelector, useDispatch } from 'react-redux'
import Spinner from '../components/Spinner'
import * as actions from '../store/slices/index'

const AuthWrapperV2 = (Component) => {
  function WrappedComponent(props) {
    const {
      userDetailsState: { loading, success, data },
    } = useSelector((state) => state.authentication)
    const dispatch = useDispatch()
    const params = getUrlParams()
    // Single source of truth for URL params — avoids duplicate parsing
    const urlParams = Object.fromEntries(
      new URLSearchParams(window.location.search).entries(),
    )

    let paramsData = {}
    try {
      paramsData = JSON.parse(decodeURIComponent(urlParams?.data || '{}'))
    } catch {
      paramsData = {}
    }
    // will Remove the auth_token once new App version 5.2.58 will get released
    const authToken = params?.auth_token || paramsData?.authToken

    const hasDispatched = useRef(false)

    useEffect(() => {
      if (hasDispatched.current || !authToken) return
      hasDispatched.current = true
      removeUrlParam('auth_token')
      // removeUrlParam('data')
      dispatch(actions.getUserDetailsRequest(authToken))
    }, [authToken, dispatch])

    const isInitializing = !!authToken && !hasDispatched.current

    if (loading || isInitializing) {
      return (
        <div className="flex justify-center items-center h-screen">
          <Spinner />
        </div>
      )
    }

    if (success && data) {
      return <Component {...props} />
    }

    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-red-500 text-base font-bold">
          Something went wrong!
        </div>
      </div>
    )
  }

  return WrappedComponent
}

export default AuthWrapperV2
